import { render, staticRenderFns } from "./AffirmModal.vue?vue&type=template&id=74c69def&"
import script from "./AffirmModal.vue?vue&type=script&lang=js&"
export * from "./AffirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports